import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'
function ViewRoom(){

    const [rows, setRows] = useState([]);
    const [roomnoView,setRoomnoView] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [roomno,setRoomno]=useState({
        "room":'',
        "room_no":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });


  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (roomnoView.length > 0) {
        setRows(roomnoView);
      }
  }, [roomnoView]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}room-no/`)
      .then(response => {
        setRoomnoView(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
  const columns = [
  { field: 'id', headerName: 'Id', width: 70 },
  {
    field: 'room',
    headerName: 'Rooms',
    width: 200,
    renderCell: (params) => params.row.room?.room || '',
  },

  { field: 'room_no', headerName: 'Room No', width: 300 },
  {
    field: 'status',
    headerName: 'Room Status',
    width: 300,
    renderCell: (params) => (
      params.value === 1 ? (
        <span style={{ backgroundColor: 'green', color: 'white', padding: '3px 10px', borderRadius: '4px' }}>
          Available
        </span>
      ) : (
        <span style={{ backgroundColor: 'red', color: 'white', padding: '3px 10px', borderRadius: '4px' }}>
         Not Available
        </span>
      )
    ),
  },
  { field: 'addedby', headerName: 'Added By', width: 120 },
];


    return (
        <section className="container mt-4">
        <div className='col-md-12 col-12 mb-2'>
        <h4 className='text-center'
           style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-bed" aria-hidden="true" style={{ color: 'red' }}></i>
       Room Status</h4>
        </div>
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>

        </section>

)
}

export default ViewRoom;